import React from 'react';
import { func } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';

const CancelButton = ({ onClick }) => (
    <button className="cancel-button" onClick={onClick}>
        <I18n k="layout.global_messages.user_activation.cancel"/>
    </button>
);

CancelButton.propTypes = {
    onClick: func.isRequired
};

export default CancelButton;
